import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconSalesComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Sales${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M8 6.877l6.384-2.683a1.314 1.314 0 00-.383-.281l-5.4-2.53a1.431 1.431 0 00-1.202 0L2 3.912c-.15.07-.273.17-.383.28L8 6.878zM7.438 7.87L1.25 5.27v5.796c-.004.48.284.922.743 1.139l5.4 2.53a.162.162 0 00.022.007l.023.008V7.87zM8.563 14.748V7.87l6.187-2.6v5.803c0 .48-.29.918-.75 1.132l-5.4 2.53-.02.007c-.006.002-.012.003-.017.006z"/></svg>;
}

const IconSales = React.forwardRef(IconSalesComponent);
export default IconSales;
